export const DEPOSIT_BLOCKED_COUNTRIES: readonly string[] = ['US'];

export function isDepositBlockedCountry(countryCode?: string | null): boolean {
  if (!countryCode) return false;
  return DEPOSIT_BLOCKED_COUNTRIES.includes(countryCode.toUpperCase());
}
